module.exports = __webpack_public_path__ + "static/zebrarecycled1-09f37d5b12a59afd6b45e13d15a8f547.png";